import * as React from 'react';
import { useSelector } from 'react-redux';

import { Flex } from '@lightspeed/flame/Core';
import { theme } from '@lightspeed/flame/Core/themes/flame';
import { Switch } from '@lightspeed/flame/Switch';
import { Text } from '@lightspeed/flame/Text';

import { getStore } from 'pages/store/selectors/employeeShops';

interface Props {
  checked: boolean;
  disabled: boolean;
  onChangeSwitch: () => void;
}

const AllShopsAccessSwitch: React.FC<Props> = ({ checked, disabled, onChangeSwitch }) => {
  const { isPrimaryUser } = useSelector(getStore);

  return (
    <Flex justifyContent="space-between" px={1} py={2}>
      <Text color={isPrimaryUser ? theme.colors['gray-400'] : theme.colors.black}>
        Allow access to all
      </Text>
      <Switch
        aria-label="switch-access-all-shops"
        data-test="switch-access-all"
        checked={checked}
        css={{ padding: 0 }}
        disabled={disabled}
        onChange={onChangeSwitch}
      />
    </Flex>
  );
};

export default AllShopsAccessSwitch;
